import { render } from "./리스트형.vue?vue&type=template&id=2305891c"
import script from "./리스트형.vue?vue&type=script&lang=js"
export * from "./리스트형.vue?vue&type=script&lang=js"

import "./리스트형.vue?vue&type=style&index=0&id=2305891c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__